import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import {
  fetchProvisionData,
  // fetchCategories,
  // fetchProducts,
  // fetchServices,
} from "../utils/api";
import * as Products from "../data-types/api-client/api-products";
import * as Contacts from "../data-types/api-client/api-contacts";

/** Define context type */
interface CatalogContextType {
  provisionData: Products.RentProvision;
  setProvisionData: (data: Products.RentProvision) => void;
  // categories: Category[];
  // products: ProductItem[];
  // services: ServiceItem[];
  originalTitle: string;
  setOriginalTitle: (title: string) => void;
  activeCategoryIndex: number;
  setActiveCategoryIndex: (index: number) => void;
  selectedCategory: number;
  setSelectedCategory: (index: number) => void;
  activeProductIndex: number;
  setActiveProductIndex: (index: number) => void;
  loading: boolean;
}

/** Create context with default value */
const CatalogContext = createContext<CatalogContextType | undefined>(undefined);

export const useCatalog = () => {
  const context = useContext(CatalogContext);
  if (!context) {
    throw new Error("useCatalog must be used within a CatalogProvider");
  }
  return context;
};

/** Define props type for CatalogProvider */
interface CatalogProviderProps {
  children: ReactNode;
}

const CatalogProvider: React.FC<CatalogProviderProps> = ({ children }) => {
  const [provisionData, setProvisionData] = useState<Products.RentProvision>({
    categories: [] as Products.RentCategory[],
    priceList: {} as Products.RentPriceList,
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // const [categories, setCategories] = useState<Category[]>([]);
  // const [products, setProducts] = useState<ProductItem[]>([]);
  // const [services, setServices] = useState<ServiceItem[]>([]);
  const [originalTitle, setOriginalTitle] = useState<string>(
    () => localStorage.getItem("originalTitle") || ""
  );
  const [activeCategoryIndex, setActiveCategoryIndex] = useState<number>(0);
  const [activeProductIndex, setActiveProductIndex] = useState<number>(
    () => Number(localStorage.getItem("activeProductIndex")) || 0
  );
  const [selectedCategory, setSelectedCategory] = useState<number>(1);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [
          fetchedProvisionData,
          // fetchedCategories,
          // fetchedProducts,
          // fetchedServices,
        ] = await Promise.all([
          fetchProvisionData(),
          // fetchCategories(),
          // fetchProducts(),
          // fetchServices(),
        ]);

        setProvisionData(fetchedProvisionData);
        // setCategories(fetchedCategories);
        // setProducts(fetchedProducts);
        // setServices(fetchedServices);
      } catch (err: any) {
        console.error(err.response?.data?.message || "Chyba s načítaním dát!");
        setError("Chyba s načítaním dát.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    localStorage.setItem("originalTitle", originalTitle || "");
    localStorage.setItem("activeProductIndex", String(activeProductIndex));
  }, [originalTitle, activeProductIndex]);

  return (
    <CatalogContext.Provider
      value={{
        provisionData,
        setProvisionData,
        // categories,
        // products,
        // services,
        originalTitle,
        setOriginalTitle,
        activeCategoryIndex,
        setActiveCategoryIndex,
        activeProductIndex,
        setActiveProductIndex,
        selectedCategory,
        setSelectedCategory,
        loading,
      }}
    >
      {children}
    </CatalogContext.Provider>
  );
};

export default CatalogProvider;
